export default __webpack_public_path__ + "static/media/CECYTEJ.dcfc35fc.png";